// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"B2-z","colorTextValue":"C2-z","swatches":"D2-z","collapseLink":"E2-z","isCollapsed":"F2-z","dropdown":"G2-z","disabled":"H2-z"};